/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

import moment from 'moment';
import _ from 'lodash';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown';
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import {
  Container,
  Row,
  Col,
  Spinner
} from 'reactstrap';

// styles
import { grayColor } from "assets/jss/material-dashboard-pro-react.jsx";
import createMemberFormStyle from "assets/jss/material-dashboard-pro-react/views/createMemberFormStyle.jsx";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withAuthentication } from "contexts/Session";

import SweetAlert from "react-bootstrap-sweetalert";
import { updateMember } from "db/member";
import { toE164 } from "helpers/phoneNumber";
import { fromE164 } from "helpers/phoneNumber";
import { FormLabel } from "@material-ui/core";
import { upsertUser } from "db";
import { ROLES } from "constants/user";
import { MEMBER_STATUS_STRING } from "constants/member";
import { changePassword } from "helpers/https";

const styles = theme => ({
  ...createMemberFormStyle,
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },
  group: {
    margin: theme.spacing(1, 0),
    flexDirection: 'row',
  },
  dateInput: {
    fontSize: '14px',
    border: 0,
  },
  inputLabel: {
    padding: '10px',
    backgroundColor: 'red'
  },
  buttonProgress: {
    color: green[100],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -15,
    marginLeft: -15,
  },
});

class CreateMemberForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      member: {
        profile_image_url: "",
        name: '',
        birthday: '',
        gender: '',
        email: '',
        phone: '',
        intro: '',
        grade: '', // 등급
        grade_id: '' // 등급자ID
      },
      isSaving: false,
      alert: null,
      uid: null,
    }
  }


  static getDerivedStateFromProps(props, state) {
    if (props.isEdit !== state.isEdit && props.uid !== state.uid) {
      const member = props.member;
      member.phone = fromE164(member.phone);

      return {
        isEdit: props.isEdit,
        uid: props.uid,
        member,
        isSaving: false
      }
    }
    return null;
  }


  componentDidMount() {
    const { currentOrg } = this.props;
    if (!currentOrg) {
      this.props.showAlertAction({
        message: "기관를 먼저 선택해주세요",
        color: "danger"
      })
    }
  }

  inputAlert = () => {
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="새 비밀번호"
          content="6글자 이상 입력해주세요."
          onConfirm={e => e.length < 6 ? alert('6글자 이상 입력해주세요.') : this.inputConfirmAlert(e)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.info
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
        />
      )
    });
  }

  inputConfirmAlert = (e) => {
    this.setState({ alert: e });
    console.log(e);
    return changePassword({ uid: this.props.uid, email: this.state.member.email, password: e })
      .then(() => this.basicAlert('변경성공'))
      .catch(e => this.basicAlert('변경실패: ', e))
  }

  basicAlert = (message) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{
            marginBottom: "3px",
            color: grayColor[2],
            fontSize: "18px",
            display: "block",
            marginTop: "-100px",
          }}
          title={message}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        />
      )
    });
  }

  successAlert = (message) => {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="저장되었습니다"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          회원 등록 완료<br />감사합니다.
        </SweetAlert>
      )
    });
  }

  hideAlert = () => {
    this.setState({
      alert: null
    });
  }

  verifyBirthday(value) {
    var birthdayRex = /^\d{4}-\d{2}-\d{2}$/;
    if (birthdayRex.test(value)) {
      return true;
    }
    return false;
  }

  // function that returns true if value is phone number, false otherwise
  verifyPhoneNumber(value) {
    var phonenumberRex = /^\d{2,3}-\d{3,4}-\d{4}$/;
    var phone1588Rex = /^\d{4}-\d{4}$/;
    if (phonenumberRex.test(value) || phone1588Rex.test(value)) {
      return true;
    }
    return false;
  }
  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  save = (e) => {
    const { member } = this.state;
    const { file } = this.state;
    const { currentOrg, is_counselor = false } = this.props;

    if (!member.name || (member?.name && member.name.length < 2)) {
      this.basicAlert("이름을 정확히 입력해주세요");
      return;
    }

    if (member?.gender === '') {
      this.basicAlert("성별을 선택해주세요");
      return;
    }

    if ((!member.email || (member.email && member.email.length === 0)) && (!member.phone || (member.phone && member.phone.length === 0))) {
      this.basicAlert("이메일 혹은 전화번호 둘 중 하나는 반드시 입력해주세요.");
      return;
    }

    if (!member.email || (member.email && member.email.length > 0 && !this.verifyEmail(member.email))) {
      this.basicAlert("이메일을 정확히 입력해주세요");
      return;
    }

    if (!this.props.isEdit) {
      if ((!member.email || (member.email && member.email.length > 0)) && (!member.password || (member.password && member.password.length < 6))) {
        this.basicAlert("이메일 로그인을 위해서 패스워드를 6자리 이상으로 설정해주세요")
        return;
      }
    }

    if (member.birthday && !this.verifyBirthday(member.birthday)) {
      this.basicAlert("생년월일 형식을 확인 바랍니다.");
      return;
    }

    if (member.phone && member.phone.length > 0 && !this.verifyPhoneNumber(member.phone)) {
      this.basicAlert("전화번호 형식을 확인 바랍니다.");
      return;
    }



    this.setState({ isSaving: true })

    const e164PhoneNumber = member.phone ? toE164(member.phone) : null;

    if (this.state.isEdit) {
      if (this.state.uid) {
        const role = this.props.currentRole
          ? this.props.currentRole.role
          : ROLES.PERSONAL_USER;

        return Promise.all([
          updateMember(currentOrg.id, this.state.uid, {
            ...member,
            is_counselor,
            phone: e164PhoneNumber
          }),
          role === ROLES.SUPER_ADMIN
            ? upsertUser(this.state.uid, {
              ...member,
              phone: e164PhoneNumber
            })
            : null
        ])
          .then(() => {
            this.setState({ isSaving: false })
            this.successAlert();
            this.props.onClose();
          })
          .catch(e => {
            this.basicAlert(e);
            this.setState({ isSaving: false })
          });
      } else {
        this.basicAlert("이용자 선택이 되지 않았네요");
      }
    } else {
      return this.props.createMemberAction(currentOrg.id, {
        ...member,
        is_counselor,
        phone: e164PhoneNumber
      })
        .then(() => {
          this.setState({ isSaving: false })
          this.successAlert();
          this.props.onClose();
        })
        .catch(e => {
          console.log("Failed setupMember: ", e.response.data.code);
          const { code } = e.response.data;
          let message = null;
          switch (code) {
            case "auth/email-already-exists":
              message = "이메일이 이미 등록되어 있습니다";
              break;

            case "auth/invalid-phone-number":
              message = "잘못된 전화번호입니다.";
              break;

            case "auth/phone-number-already-exists":
              message = "이미 등록된 전화번호입니다";
              break;

            case "auth/invalid-credential":
              message = "잘못된 인증입니다";
              break;

            default:
            // do nothing
          }

          this.basicAlert(message);
          this.setState({ isSaving: false })
        });
    }
  }

  onFileLoaded = (file, isRemoved = false) => {
    if (isRemoved) {
      this.setState({ file: null, member: { ...this.state.member, profile_image_url: null } });
    } else {
      this.setState({ file });
    }
  }

  render() {
    const { member, isEdit } = this.state;
    const { classes, is_counselor = false } = this.props;
    console.log('state.member = ', member);
    return (
      <Container>
        <Row className='pt-1'>
          <Col>
            <Row>
              <Col>
                <CustomInput
                  labelText="*이름"
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: false,
                    value: member.name,
                    onChange: event => this.setState({ member: { ...member, name: event.target.value } })
                  }}
                />
              </Col>
              <Col>
                <FormControl component="fieldset" className={styles.formControl}>
                  <FormLabel component="legend">성별</FormLabel>
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="gender"
                    value={String(member.gender)}
                    onChange={event => this.setState({ member: { ...member, gender: Number(event.target.value) } })}
                  >
                    <FormControlLabel value="0" control={<Radio />} label="여자" />
                    <FormControlLabel value="1" control={<Radio />} label="남자" />
                  </RadioGroup>
                </FormControl>
              </Col>
            </Row>
            <Row className='pt-1'>
              <Col className='col-6'>
                <CustomInput
                  labelText="이메일 주소"
                  id="email-address"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: isEdit && this.verifyEmail(this.props.member.email),
                    value: member.email,
                    onChange: event => this.setState({ member: { ...member, email: event.target.value } })
                  }}
                />
              </Col>
              {
                isEdit
                  ? <Button onClick={() => this.verifyEmail(member.email) ? this.inputAlert() : alert('이메일을 먼저 입력해주세요')} color='primary' size='sm' simple >비밀번호 재설정</Button>
                  : <Col>
                    <CustomInput
                      labelText="이메일 로그인용 암호"
                      id="email-login-password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: member.password,
                        onChange: event => this.setState({ member: { ...member, password: event.target.value } })
                      }}
                    />
                  </Col>
              }
            </Row>
            <Row className='pt-1'>
              <Col>
                <label>*생년월일</label>
                <CustomInput
                  id="birthday"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: 'date',
                    value: member.birthday
                      ? member.birthday.constructor.name === 'String'
                        ? member.birthday
                        : moment(member.birthday?.toDate()).format('YYYY-MM-DD')
                      : null,
                    onChange: event => this.setState({ member: { ...member, birthday: event.target.value } })
                  }}
                />
              </Col>
              <Col>
                <CustomInput
                  labelText="전화번호 예) 010-5555-5555"
                  id="phone"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: isEdit,
                    value: member.phone,
                    onChange: event => this.setState({ member: { ...member, phone: event.target.value } })
                  }}
                />
              </Col>
            </Row>
            {
              is_counselor
                ? null
                : <Row className='pt-1'>
                  <Col>
                    <FormControl component="fieldset" className={styles.formControl}>
                      <FormLabel component="legend">요양등급</FormLabel>
                      <RadioGroup
                        row
                        aria-label="grade"
                        name="grade"
                        value={member.grade}
                        onChange={event => this.setState({ member: { ...member, grade: event.target.value } })}
                      >
                        <FormControlLabel value="장기요양 5등급" control={<Radio />} label="장기요양 5등급" />
                        <FormControlLabel value="인지지원등급" control={<Radio />} label="인지지원등급" />
                        <FormControlLabel value="등급 없음" control={<Radio />} label="등급 없음" />
                      </RadioGroup>
                    </FormControl>
                  </Col>
                  <Col>
                    <CustomInput
                      labelText="장기요양인정번호"
                      id="grade_id"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: member.grade_id,
                        onChange: event => this.setState({ member: { ...member, grade_id: event.target.value } })
                      }}
                    />
                  </Col>
                </Row>
            }
            {
              [ROLES.SUPER_ADMIN, ROLES.ORG_ADMIN].includes(this.props.currentRole?.role)
                ? <Row className='mt-3'>
                  <Col className='col-6 ml-5 mr-5'>
                    <div className='text-center d-inline-flex justify-content-center align-items-center'>
                      <label className='mr-5'>현재 상태</label>
                      <CustomDropdown
                        buttonText={MEMBER_STATUS_STRING[member["status"] - 1]}
                        hoverColor="info"
                        buttonProps={{
                          round: true,
                          block: true,
                          color: "primary"
                        }}
                        dropPlacement="bottom"
                        dropdownList={MEMBER_STATUS_STRING}
                        onClick={(params) => {
                          const status = _.findIndex(MEMBER_STATUS_STRING, o => o == params) + 1;
                          member.status = status;
                          this.setState({ member });
                          console.log("params = ", params);
                          console.log("status = ", status);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                : null
            }
          </Col>
        </Row>
        <Row className='pl-0 pr-0 pt-3'>
          <Col className='d-inline-flex justify-content-between'>
            <Button color="rose" onClick={this.props.onClose}>
              취소
                </Button>
            <Button
              color="primary"
              onClick={this.save}
              disabled={this.state.isSaving}
            >
              {
                isEdit
                  ? "저장하기"
                  : "생성하기"
              }
              {this.state.isSaving ? <Spinner size='sm' color='light' /> : null}
            </Button>
          </Col>
        </Row>

        {this.state.alert}
      </Container>
    )
  }
}
CreateMemberForm.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    currentOrg: state.org.currentOrg,
    currentUser: state.auth.currentUser,
    currentRole: state.auth.currentRole,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  withAuthentication,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CreateMemberForm);
